var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrigger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.60438 1.75C4.3711 1.75 1.75 4.3711 1.75 7.60438C1.75 10.3285 3.61121 12.6197 6.13248 13.2724C6.53348 13.3762 6.77441 13.7854 6.67061 14.1864C6.56681 14.5874 6.15759 14.8283 5.75659 14.7245C2.58972 13.9048 0.25 11.0288 0.25 7.60438C0.25 3.54267 3.54267 0.25 7.60438 0.25C11.3553 0.25 14.4494 3.05743 14.9019 6.68603C14.9532 7.09706 14.6615 7.47182 14.2505 7.52307C13.8394 7.57432 13.4647 7.28267 13.4134 6.87164C13.0534 3.9845 10.5893 1.75 7.60438 1.75Z",
    fill: "#313131"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.96201 6.40061C7.1745 6.22064 7.46921 6.17322 7.72743 6.27744L15.9459 9.59443C16.226 9.70748 16.411 9.97753 16.4152 10.2796C16.4193 10.5816 16.2419 10.8566 15.965 10.9774L12.2211 12.6102L9.99426 16.0342C9.82958 16.2875 9.52907 16.4172 9.23185 16.3633C8.93463 16.3095 8.69872 16.0826 8.63332 15.7877L6.71452 7.1353C6.65423 6.86345 6.74952 6.58057 6.96201 6.40061ZM9.71091 13.7186L11.0863 11.6038C11.1664 11.4807 11.2807 11.3839 11.4152 11.3252L13.7277 10.3167L8.48746 8.20175L9.71091 13.7186Z",
    fill: "#313131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrigger);
export default __webpack_public_path__ + "static/media/trigger.4873b17bef8ef77256b34fbd70f7e82e.svg";
export { ForwardRef as ReactComponent };